import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ion-button'
})
export class BlurButtonDirective {
  constructor(private elementRef: ElementRef<HTMLElement>) {}

  @HostListener('click', ['$event.target.value'])
  clickEvent() {
    this.elementRef.nativeElement.blur();
  }
}
